import { gql } from "@apollo/client";

export const USE_VSME_REPORT = gql`
    mutation UseVsmeReport($documents: [String!]) {
        useVsmeReport(documents: $documents) {
            id
            status
            submittedAt
        }
    }
`; 